import { Box } from '@chakra-ui/react'
import ResponsiveNavBar from './components/ResponsiveNavBar';
import styles from './NavBar.module.scss'
import { NavProps_t } from './NavBarTypes/NavItem';
import cn from 'classnames'


function NavBar({ navItems, sticky, maxWidth, logoUrl }: NavProps_t) {
    // const themeStyles = useStyleConfig('NavBar')
    return (    
        <>
            {
                sticky ?
                    (<Box
                        className={styles['sticky__nav-bar__container']}
                        position={"absolute"} zIndex={1} m={0}>
                        <Box
                            className={cn(styles['sticky__nav-bar'])}
                            position={"sticky"}
                            zIndex={0}
                            minHeight={"5rem"}
                            height={"10vh"}
                            width={"100vW"}
                            maxW={{ base: "100vW", "2xl": maxWidth }}
                            top={0}
                            left={0}>
                            <ResponsiveNavBar navItems={navItems} maxWidth={maxWidth} logoUrl={logoUrl} />
                        </Box>
                    </Box>) : <Box className={styles['non-sticky__nav-bar']}
                        bg={"rgba(123, 60, 45, 0.5)"}
                        position={"relative"} zIndex={99999}
                        top={0}
                        minHeight={"5rem"}
                        height={"10vh"}
                        width={"100vW"}
                        maxW={{ base: "100vW", "2xl": maxWidth }}
                    >
                        <ResponsiveNavBar navItems={navItems} maxWidth={maxWidth} logoUrl={logoUrl} />
                    </Box>
            }
        </>
        )
}

export default NavBar;
